import type { IconDefinition } from '../index.tsx';

export const iconEyeOff: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconEyeOff',
  icon: [
    16,
    16,
    [],
    '',
    'M16 16H13L10.8368 13.3376C9.96488 13.7682 8.99592 14 8 14C6.09909 14 4.29638 13.1557 3.07945 11.6953L0 8L3.07945 4.30466C3.14989 4.22013 3.22229 4.13767 3.29656 4.05731L0 0H3L16 16ZM8.84053 10.8807L5.35254 6.58774C5.12755 7.00862 5 7.48941 5 8C5 9.65685 6.34315 11 8 11C8.29178 11 8.57383 10.9583 8.84053 10.8807Z M16 8L14.2278 10.1266L7.63351 2.01048C7.75518 2.00351 7.87739 2 8 2C9.90091 2 11.7036 2.84434 12.9206 4.30466L16 8Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
